'use client'

import React, { useState, useContext, useEffect, useCallback } from "react"
import Step0 from "./step0"
import Step1 from "./step1"
import { setToLocalStorage, removeFromLocalStorage } from "../../common/util"
// import PubSub from "pubsub-js"
// import { EVENT_REFRESH_USER, EVENT_LOGIN_CALLBACK } from "../../common/event"
// import { loginByThird } from "./service"
import styles from './login.module.css'
import loginBg from './assets/bg.png'
import { AuthCacheKey, AuthIdCacheKey, UCUidCacheKey } from "../../config"
// import type { Dict } from "@/app/lib/definitions";

function Login({ toggleLoginDialog, refreshUser

}: { toggleLoginDialog: (v: boolean) => void, refreshUser: () => void }) {
    const [step, setStep] = useState(0)
    const [email, setEmail] = useState('')
    const cancelLogin = useCallback(() => {
        toggleLoginDialog(false)
        // tryToReportDC('webclick', 'cancel_sign_in', 'sign_in', 'click');
    }, [toggleLoginDialog])
    const loginCallback = useCallback((data: any) => {
        const { accessToken, uid, ucUserId } = data
        setToLocalStorage(AuthCacheKey, accessToken)
        setToLocalStorage(AuthIdCacheKey, uid + '')
        setToLocalStorage(UCUidCacheKey, ucUserId + '')
        refreshUser();
        // PubSub.publish(EVENT_REFRESH_USER)
        // PubSub.publish(EVENT_LOGIN_CALLBACK)
        cancelLogin()
        // window.century_setting.uid = ucUserId + ''
        // window.century_setting.business_uid = uid + ''
        removeFromLocalStorage('_cspt')
        removeFromLocalStorage('_sfsp')
        removeFromLocalStorage('_sfpc')
        // tryToReportMp('trackCustom', 'register')
        // setCookie(IsLoginCacheKey, 'True')
    }, [cancelLogin])
    // const loadggFlag = useRef(false)

    const passEmail = (value: string) => {
        setEmail(value)
        setStep(1)
    }

    const backToStep0 = () => {
        setStep(0)
    }

    return <div className={'view-port-mask'}>
        <div className={styles['login-container']}>
            <div className={styles['login-layout']}>
                {/* <div className={styles['login-ad-wrapper']}>
                    <div className={styles['login-ad-img-box']}>
                        <img alt="login-ad" className={styles['login-ad-img']} src={loginBg} />
                    </div>
                </div> */}
                <div className={styles['login-content-wrapper']}>
                    <i className={styles['login-close']} onClick={cancelLogin}></i>
                    <Step0
                        initialValue={email}
                        passEmail={passEmail}
                        show={step === 0}
                        containerShow={true}
                        userReadyState={true}
                        isLogin={false}
                        loginCallback={loginCallback}
                        cancelLogin={cancelLogin}
                    />
                    {
                        step === 1 && <Step1 email={email} back={backToStep0} loginCallback={loginCallback} />
                    }
                </div>
            </div>
        </div>
    </div>
}

export default Login